import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';

export interface Option {
  companyName: string;
  companyId: string;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent {
  @ViewChild(MatAutocompleteTrigger) trigger!: MatAutocompleteTrigger;
  @ViewChild('input') input!: ElementRef;
  @Input() control!: FormControl;
  @Input() label!: string;
  @Input() options!: Array<any>;
  @Input() error: string | null = '';
  @Input() loading!: boolean;
  @Output() searchSelected = new EventEmitter<boolean>();
  selectedOption!: string;
  isOther = false;
  panelOpen = false;
  length = 0;

  calculatePanelWidth(): void {
    this.length = this.input.nativeElement.offsetWidth + 70;
  }

  handleOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.selectedOption = event.option.value;
    this.panelOpen = false;
    this.searchSelected.emit(true);
  }

  handleOpen(): void {
    this.panelOpen = true;
    this.searchSelected.emit(false);
  }

  handleClose(): void {
    this.panelOpen = false;
  }

  displayFn(option: Option): string {
    return option.companyName ? option.companyName : '';
  }
}
